import React, { useState } from 'react';

import { Button, Drawer, Grid, IconButton, Link } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { Launch as ExternalLinkIcon } from '@material-ui/icons';

import styleDrawer from '../../themes/drawer';

const useStyles = styleDrawer;

export default function TemporaryDrawer({ buttonHead, children, iconButtonAction, labeButtonAction, title, submitButtonLabel, headerButton, showExternalLink }) {
  const classes = useStyles();
  const [state, setState] = useState({ right: false });
  localStorage.setItem('adireto-drawer-open', true);
  const toggleDrawer = (side, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    localStorage.setItem('adireto-drawer-open', open);
    setState({ ...state, [side]: open });
  };

  const ButtonHeadDefault = () => {
    return (
      (headerButton !== "off" ?
        <Button color="primary" variant="contained" fullWidth
          form="myForm" type="submit" onClick={() => {
            setTimeout(() => {
              while (localStorage.getItem('adireto-drawer-open') === "false") {
                setState({ ...state, 'right': false });
                localStorage.setItem('adireto-drawer-open', true);
              }
            }, 3000)
          }}
        >
          {(submitButtonLabel ? submitButtonLabel : "SAVE")}
        </Button> : (<></>))
    )
  }

  const DrawerHeader = () => {
    return (
      <>
        <div className={classes.drawerHead}>
          <Grid container spacing={0}>
            <Grid item xs={9}>
              <h2>
                <IconButton onClick={toggleDrawer('right', false)} style={{ padding: 6 }}>
                  <CloseIcon />
                </IconButton>
                {title}
              </h2>
            </Grid>
            <Grid item xs={3}>
              {buttonHead ? buttonHead : <ButtonHeadDefault />}
            </Grid>
          </Grid>
        </div>
      </>
    );
  };

  const IconButtonT = () => {
    return (
      <IconButton variant="outlined" onClick={toggleDrawer('right', true)}>
        {iconButtonAction}
      </IconButton>
    );
  }

  const LabelButton = () => {
    const externalLink = `https://${labeButtonAction}`;
    return (
      <Grid container>
        {showExternalLink && (
          <Grid item xs={1}>
            <Link href={externalLink} target="_blank" rel="noreferrer">
              <ExternalLinkIcon fontSize="small" />
            </Link>
          </Grid>
        )}

        <Link onClick={toggleDrawer('right', true)}>
          {labeButtonAction}
        </Link>
      </Grid>
    );
  }

  const ActionButtonAdd = () => {
    return (
      <Button variant="outlined" color="primary" fullWidth onClick={toggleDrawer('right', true)}>
        {labeButtonAction}
      </Button>
    );
  }

  return (
    <>
      {(!!iconButtonAction) ? <IconButtonT /> : (labeButtonAction === 'Add') ? <ActionButtonAdd /> : <LabelButton />}
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer('right', false)}>
        <div className={classes.boxDrawer} role="presentation">
          <Grid container spacing={0} className={classes.containerDrawer}>
            <Grid item xs={12}>

              <DrawerHeader />

              <div className={classes.drawerBody}>
                {children}
              </div>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    </>
  );
};